import { render, staticRenderFns } from "./addOrderMode.vue?vue&type=template&id=013ace4b&scoped=true&"
import script from "./addOrderMode.vue?vue&type=script&lang=js&"
export * from "./addOrderMode.vue?vue&type=script&lang=js&"
import style0 from "./addOrderMode.vue?vue&type=style&index=0&id=013ace4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ace4b",
  null
  
)

export default component.exports